<template>
    <div>
        <table class="table overflow-auto">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">{{ trans('general.page.space_billing.items.product') }}</th>
                    <th scope="col">{{ trans('general.page.space_billing.items.tax') }}</th>
                    <th scope="col">{{ trans('general.page.space_billing.items.price') }}</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" class="item mb-2" :key="'item-' + (index + 1)">
                    <td>{{ index + 1 }}</td>
                    <td class="w-30">
                        <product-select :ref="'productSelect'" @change="onProductSelect($event, index)" :simple="true"
                                        :disabled="invoice && invoice.status !== STATUS_DRAFT"
                                        v-on:add-product="openAddProductForm(index)" v-model="item.product"
                                        :background="'bg-transparent'"/>
                    </td>
                    <td class="w-30 align-items-center">
                       <span class="py-1">
                            {{ item.currency_symbol }} {{calculateItemTax(item)}}
                       </span>
                    </td>
                    <td>
                        <div class="d-flex gap-2 align-items-center">
                            {{ item.currency_symbol }}
                            <input type="number" class="form-control bg-transparent" v-model="item.price"
                                   step="0.01"
                                   :disabled="(invoice && invoice.status !== STATUS_DRAFT) || !item.product "
                                   @change="emitChanges"
                                   :placeholder="trans('general.page.space_billing.items.price')"/>
                        </div>
                    </td>
                    <td>
                        <button v-if="items.length > 1 && (!invoice || invoice?.status === STATUS_DRAFT)"
                                type="button" class="btn btn-sm btn-icon" @click="removeRow(index)">
                            <i class="fi fi-rr-trash"></i></button>
                    </td>
                </tr>
                <tr class="px-0 py-2">
                    <td colspan="5">
                        <button v-if="!invoice || invoice?.status === STATUS_DRAFT" type="button" class="btn btn-sm btn-icon-split btn-add btn-secondary " @click="addRow">
                            <i class="icon fi fi-rr-add"></i>
                            <span class="text">{{ trans('general.defaults.add') }}</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ProductSelect from "../../../theme/atoms/ProductSelect.vue";
import RecurringTypeSelect, {RECURRING_TYPES} from "../../../theme/atoms/RecurringTypeSelect";
import {EMIT_ITEMS_CHANGE, getSpaceCurrency, STATUS_DRAFT, STATUS_OPEN} from "../../../services/SpaceBillingContants";
import {round} from "../../../services/MathFunctions";
import AddProductQuickForm from "../../../theme/molecules/AddProductQuickForm.vue";

export default {
    name: "InvoiceItems",
    props: {
        invoice: {
            type: Object,
            required: false
        },
        newProduct: {
            type: Object,
        },
        products: {
            type: Array,
            required: false
        },
        taxRate: {
            type: Object,
            required: false
        },
    },
    components: {
        ProductSelect,
        RecurringTypeSelect,
        AddProductQuickForm,
    },
    watch: {
        items: function (val) {
            if (this.itemsWatcher) {
                this.$emit(EMIT_ITEMS_CHANGE, val)
            }
        },
        products: function (items) {
            if (items && items.length) {
                this.itemsWatcher = false;
                items.map(v => {
                    v.recurring = RECURRING_TYPES.filter(type => type.code === v.recurring_type)[0]
                    return v;
                });

                this.items = [...items];
            }
        },
    },
    data() {
        return {
            itemsWatcher: true,
            STATUS_OPEN,
            STATUS_DRAFT,
            currency: null,
            items: [
                {
                    name: null,
                    description: null,
                    price: null,
                    tax: null,
                    quantity: null,
                    discount: null,
                    discount_type: null,
                    recurring: null,
                    currency_code: null,
                    currency_symbol: null,
                    product: null,
                }
            ],
        }
    },
    methods: {
        addRow() {
            this.items.push({
                name: ' ',
                description: null,
                price: null,
                quantity: null,
                discount: null,
                discount_type: null,
                recurring: null
            })
        },
        removeRow(index) {
            this.items.splice(index, 1)
            this.emitChanges();
        },
        onProductSelect(product, index) {
            this.emitChanges();
            if (!product) {
                return;
            }

            this.transferProductToItem(product, this.items[index])
        },
        transferProductToItem(product, item) {
            item.price = (product.price / 100);
            item.description = product.description;
            item.quantity = item.quantity ?? 1;
            item.recurring = {...RECURRING_TYPES[0]};
            item.recurring_type = {...RECURRING_TYPES[0]}.code;
            item.currency_code =  this.currency?.code;
            item.currency_symbol = this.currency?.symbol;
            item.space_product_id = item.space_product_id ?? product.id;
            item.name = product.name;
            item.description = product.description;
        },
        openAddProductForm(index) {
            const productPanel = this.$showPanel({
                component: AddProductQuickForm,
                openOn: 'right',
                width: 576,

                disableBgClick: true,
                cssClass: 'sidePanel',
            });
            productPanel.promise.then(result => {
                if (result.id) {
                    this.$refs['productSelect'][index].setProduct(result)
                }
            });
        },
        emitChanges() {
            this.$emit(EMIT_ITEMS_CHANGE, this.items)
        },
        calculateItemTax(item) {
            if (!this.taxRate) return 0;

            const itemPrice = item.price * item.quantity;
            const itemTax = (itemPrice / (100 / Number(this.taxRate.value) + 1));

            return round(itemTax, 2).toFixed(2);
        },
    },
    mounted() {
        getSpaceCurrency().then(currency => this.currency = currency)
    }
}
</script>

<style scoped>
tr.item {
    border-style: solid !important;
    border-bottom-width: 1px;
    padding: 3px 0;
}

.w-30 {
    width: 30%
}

</style>
